// extracted by mini-css-extract-plugin
export default {"CustomCheckBox":"styles_CustomCheckBox__MC4cQ"};